import supportedLanguages from './supportedLanguages';

const defaultLanguage = 'en';

const getLanguageOptionsByCodes = (languageCodes = [defaultLanguage]) => supportedLanguages.filter(
  ({ value }) => (languageCodes || [defaultLanguage]).includes(value),
);

export default getLanguageOptionsByCodes;
